import script from "./ConsigneeAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsigneeAddress.vue?vue&type=script&setup=true&lang=js"

import "./ConsigneeAddress.vue?vue&type=style&index=0&id=34467621&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34467621"]])

export default __exports__